import StoryPay from './src/StorePay.vue';

import Home from './src/Home.vue';
import payResult from './src/payResult.vue';
import orderList from './src/orderList.vue';
import outPayList from './src/outPayList.vue';
import Login from './src/Login.vue';


let views = {
    Login,
    Home,
    StoryPay ,  // 任务反馈入口
    payResult, //支付结果
    orderList,
    outPayList
};

export default views;